// Golden Ticket is a Sundays-only feature per the Feb 2026 monetization rules.
// JS `getUTCDay()` returns 0 for Sunday. Keep this in one place so every
// entry point (AppShell FAB auto-prompt, LeftRail button, MobileHeader button,
// GoldenTicketModal) agrees.
export function isGoldenTicketDay(date = new Date()) {
  return date.getUTCDay() === 0;
}
